module.exports = __webpack_public_path__ + "static/media/cifar7.214fe072.png";